// extracted by mini-css-extract-plugin
export default {"root":"CollapseControls_root__zLs2R","btn":"CollapseControls_btn__JcaLK"};